const BASE_URL = 'https://api.monrapidoo.com/package';
const GROUP_QUERY = '?group=ultraxeno';

export const EVENTS = {
  PACKAGES: {
    LOAD: 'packages.load',
    LOADED: 'packages.loaded',
    LOAD_ERROR: 'packages.load_error',
    CREATE: 'packages.create',
    CREATED: 'packages.created',
    // Details events
    DETAIL: 'packages.detail',
    DETAIL_LOADING: 'packages.detail_loading',
    DETAIL_LOADED: 'packages.detail_loaded',
    DETAIL_ERROR: 'packages.detail_error',
    // Wizard events
    WIZARD_OPEN: 'packages.wizard.open',
    WIZARD_CLOSE: 'packages.wizard.close',
    WIZARD_COMPLETE: 'packages.wizard.complete',
    // Fees calculation
    FEES_CALCULATE: 'packages.fees.calculate',
    FEES_CALCULATING: 'packages.fees.calculating',
    FEES_CALCULATED: 'packages.fees.calculated',
    FEES_CALCULATE_ERROR: 'packages.fees.calculate_error',
    // Delivery events
    DELIVERY_CREATE: 'packages.delivery.create',
    DELIVERY_CREATING: 'packages.delivery.creating',
    DELIVERY_CREATED: 'packages.delivery.created',
    DELIVERY_CREATE_ERROR: 'packages.delivery.create_error',
    // Delivery events
    LAUNCH_PAYMENT_LINK_PAYMENT: 'packages.delivery.LAUNCH_PAYMENT_LINK_PAYMENT',
    PAYMENT_LINK_PAYMENT_LAUNCHING: 'packages.delivery.PAYMENT_LINK_PAYMENT_LAUNCHING',
    PAYMENT_LINK_PAYMENT_LAUNCHED: 'packages.delivery.PAYMENT_LINK_PAYMENT_LAUNCHED',
    PAYMENT_LINK_PAYMENT_LAUNCH_ERROR: 'packages.delivery.PAYMENT_LINK_PAYMENT_LAUNCH_ERROR',
    // Tracking search events
    TRACKING_SEARCH: 'packages.tracking.search',
    TRACKING_SEARCHING: 'packages.tracking.searching',
    TRACKING_FOUND: 'packages.tracking.found',
    TRACKING_NOT_FOUND: 'packages.tracking.not_found',
    TRACKING_SEARCH_ERROR: 'packages.tracking.search_error'
  }
};

export const ENDPOINTS = {
  PACKAGES: {
    // GET  /package/list?group=ultraxeno&userId=...&status=...
    LOAD: `${BASE_URL}/list${GROUP_QUERY}`,
    // POST /package/create?group=ultraxeno
    CREATE: `${BASE_URL}/create${GROUP_QUERY}`,
    // POST /package/create?group=ultraxeno  (alias — même endpoint)
    DELIVERY_CREATE: `${BASE_URL}/create${GROUP_QUERY}`,
    // POST /package/calculate/fee?group=ultraxeno
    FEES_CALCULATE: `${BASE_URL}/calculate/fee${GROUP_QUERY}`,
    // GET  /package/track/:reference?group=ultraxeno
    TRACKING_SEARCH: `${BASE_URL}/track/:code${GROUP_QUERY}`,
    // GET  /package/details/:packageId?group=ultraxeno
    DETAILS: `${BASE_URL}/details/:id${GROUP_QUERY}`,
  }
};
